"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const AccountMenu_1 = __importDefault(require("../AccountMenu"));
const ANIMATION_TIME = 700;
function AccountInfoSidePanel({ isOpen, onCloseSidePanel, }) {
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: ANIMATION_TIME, classNames: "slide", unmountOnExit: true, appear: true, children: (0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(ButtonContainer, { children: (0, jsx_runtime_1.jsx)(ui_1.ToolBarBaseButton, { onClick: onCloseSidePanel, "$flashOnClick": true, width: 40, height: 40, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Back_Full_Arrow, width: 24, height: 24 }) }) }), (0, jsx_runtime_1.jsx)(AccountMenu_1.default, {})] }) }));
}
exports.default = AccountInfoSidePanel;
const Container = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 296px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-top: 0px;
  border-radius: 0px;
  box-sizing: border-box;
  color: ${props => props.theme.white};
  z-index: 999;

  background-color: ${props => props.theme.grasshopper.background};

  &.slide-enter {
    transform: translateX(-100%);
  }
  &.slide-enter-active {
    transform: translateX(0);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
  &.slide-exit {
    transform: translateX(0);
  }
  &.slide-exit-active {
    transform: translateX(-100%);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
`;
const ButtonContainer = styled_components_1.default.div `
  display: flex;
  justify-content: start;
`;
